<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../../_common/z/ztab.svelte'
    import GoalboardDash from './goalboard-dash.svelte'
    import GoalboardConfig from '../../account/goals/goalboard-config.svelte'
    import { isFullscreen } from '../../_common/stores'
    import GoalboardMembers from './goalboard-members.svelte'
    import { onMount } from 'svelte'
    let fullscreen = false
    isFullscreen.subscribe((value) => {
        fullscreen = value
    })

    let tabs = []
    onMount(async () => {
        if (window.store.token.permissions.goals.general.read) {
            tabs.push({
                title: 'Geral',
                url: '/tools-goalboard/dash',
            })
        }
        if (window.store.token.permissions.goals.individual.read) {
            tabs.push({
                title: 'Individual',
                url: '/tools-goalboard/user',
            })
        }
        tabs = tabs
    })
</script>

<div class="root-content">
    <Ztab class={fullscreen ? 'h-all' : 'mt-2'} {tabs} />
    <Router>
        {#if window.store.token.permissions.goals.general.read}
            <Route path="/dash">
                <GoalboardDash />
            </Route>
        {/if}
        {#if window.store.token.permissions.goals.individual.read}
            <Route path="/user">
                <GoalboardMembers></GoalboardMembers>
            </Route>
        {/if}
    </Router>
</div>

<style>
</style>
